import { Slide } from "react-reveal";

const HomeCTASection = () => {
  return (
    <section className=" section-spacing-80">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600 margin-auto">
              <Slide top>
                <h2 className="section-title">
                  <span className="flexi-gold">Flexi Painters</span>
                </h2>
              </Slide>
            </div>
            <div className="section-body width-600 margin-auto center">
              <h3 className="section-cta-title">
                <span className="flexi-green">Ready to have your property</span>{" "}
                professionally painted?
              </h3>
            </div>
            <div className="section-footer section-spacing-40 no-padding-bottom">
              <ul className="section-cta-options-container">
                <li>
                  <h4>Call US</h4>
                  <a href="tel:+256775866449" className="boldTitle">
                    +256-775-866-449
                  </a>
                </li>
                <li>
                  <h4>Email Us</h4>
                  <a
                    href="mailto:flexipainters@gmail.com"
                    className="boldTitle"
                  >
                    info@flexipainters.com
                  </a>
                </li>
                <li>
                  <h4>Chat with Us</h4>
                  <a
                    href="https://wa.me/256775866449"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boldTitle"
                  >
                    24/7 WhatsApp Chat
                  </a>
                </li>
              </ul>
              <div className="section-footer-cta-container center section-spacing-50">
                <a
                  href="https://form.jotform.com/flexipainters/book-site-visit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button section-main-cta"
                >
                  Book Site Visit
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCTASection;
